module.exports = __webpack_public_path__ + "img/30.f42b1333.jpg";